import {
  ADD_TO_CART_REQUEST,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_FAIL,
  REMOVE_FROM_CART_REQUEST,
  REMOVE_FROM_CART_SUCCESS,
  REMOVE_FROM_CART_FAIL,
  CLEAR_CART,
  TOTAL_PRICE,
  CLEAR_MESSAGE_ERROR

} from '../actions/actionTypes'

const cartItems = localStorage.getItem('cartItems');

const init = {
  loading: false,
  cartItems: cartItems ? JSON.parse(cartItems) : [],
  totalPrice: 0,
  publicationIds: cartItems ? JSON.parse(cartItems).map(item => item._id) : []
}

export const cartReducer = (state = init, action) => {
  switch (action.type) {
    case ADD_TO_CART_REQUEST:
      return {
        ...state,
        loading: true
      }

    case ADD_TO_CART_SUCCESS:
      const item = action.payload
      const isItemExists = state.cartItems.find(i => i._id === item._id)
      if (isItemExists) {
        return {
          ...state,
          message: 'Item updated successfully'
        }

      } else {
        return {
          cartItems: [...state.cartItems, item],
          publicationIds: [...state.publicationIds, item._id],
          message: "Item added successfully"
        }
      }

    case ADD_TO_CART_FAIL:
      return {
        ...state,
        loading: false,
        message: 'Failed to add to cart'
      }

    case REMOVE_FROM_CART_REQUEST:
      return {
        ...state,
        loading: false,
      }

    case REMOVE_FROM_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        cartItems: state.cartItems.filter(item => item._id !== action.payload),
        publicationIds: state.publicationIds.filter(item => item !== action.payload)
      }

    case REMOVE_FROM_CART_FAIL:
      return {
        ...state,
        loading: false,
        message: 'Failed to remove from cart'
      }

    case TOTAL_PRICE:
      return {
        ...state,
        totalPrice: state.cartItems.reduce((acc, item) => item.quantity * (item.price - item.discount) + acc, 0),
      }

    case CLEAR_CART:
      return {
        ...init
      };

    case CLEAR_MESSAGE_ERROR:
      return {
        ...state,
        message: false,
        error: false
      };

    default: return state
  }
}